<template>
    <v-content class="d-inline-block">
        <a @click="edit" v-if="!editMode">{{ shortname }}.{{ext}}</a> <v-icon @click="edit" v-if="!editMode" small>mdi-pencil</v-icon>
        <v-text-field v-if="!!editMode" v-model="shortname" append-icon="mdi-check" @click:append="save"></v-text-field>
    </v-content>
</template>

<script>
  export default {
    name: 'audioRenamer',
    props: ['file', 'mode'],
    data() {
      return {
        oldFile: this.file,
        fileName: this.file.name,
        editMode: false,
        shortname: null,
        ext: null,
        oldname: null,
      }
    },
    methods: {
      edit() {

        this.editMode = true
      },
      save() {
        this.editMode = false
        this.change()
      },
      change() {
          this.$emit('change', {
            fileInfo: this.oldFile,
            name: this.shortname + '.' + this.ext
          })
      }
    },
    mounted() {
      this.oldname = JSON.parse(JSON.stringify(this.fileName))
      this.shortname = JSON.parse(JSON.stringify(this.fileName))
      let fileFullName = this.shortname.split('.')
      this.ext = JSON.parse(JSON.stringify(fileFullName[fileFullName.length - 1]))
      let preName = ''
      for(let i in fileFullName) {
        if(i !== (fileFullName.length - 1)) preName += (fileFullName[i])
      }
      this.shortname = JSON.parse(JSON.stringify(preName))
    }
  }
</script>

<style scoped>

</style>